import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_RESOLVABLE_SERVICES,
  PATH_RESOLVABLE_SERVICES_NEW,
} from '../../app/constants/paths.constant';
import { FormVariant } from '../../forms';
import { ResolvableServiceForm } from '../../forms/ResolvableService';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewResolvableServicePage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ResolvableServices);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'un Service")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_RESOLVABLE_SERVICES,
            label: 'services',
            key: 'resolvableServices',
          },
          {
            to: PATH_RESOLVABLE_SERVICES_NEW,
            label: 'nouveau',
            key: 'newResolvableService',
          },
        ]}
      />
      <PageTitle title="Création d'un Service" />
      <ResolvableServiceForm
        formVariant={FormVariant.Creation}
        showCancelButton={false}
      />
    </>
  );
};
